var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedIn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 26.25H11.25V11.25H16.25V13.75C17.3158 12.3941 18.932 11.5857 20.6563 11.5462C23.757 11.5635 26.259 14.0867 26.25 17.1875V26.25H21.25V17.8125C21.05 16.4158 19.8522 15.3795 18.4413 15.3825C17.8241 15.402 17.2416 15.6722 16.828 16.1308C16.4145 16.5893 16.2058 17.1966 16.25 17.8125V26.25ZM8.75 26.25H3.75V11.25H8.75V26.25ZM6.25 8.75C4.86929 8.75 3.75 7.63071 3.75 6.25C3.75 4.86929 4.86929 3.75 6.25 3.75C7.63071 3.75 8.75 4.86929 8.75 6.25C8.75 6.91304 8.48661 7.54893 8.01777 8.01777C7.54893 8.48661 6.91304 8.75 6.25 8.75Z",
    fill: "url(#paint0_linear_1244_1198)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1244_1198",
    x1: 3.75,
    y1: 15,
    x2: 26.25,
    y2: 15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgb(29, 29, 23)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "rgb(44, 44, 43)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/LinkedIn.11a6b31282e474cdce53418c19551a84.svg";
export { ForwardRef as ReactComponent };